import React from 'react';
import PropTypes from 'prop-types';
import { classnames } from '../../utils/classnames'

import './ticket-card.css';

export function TicketCardHeader({ children = null, className = '' }) {
    return <div className={classnames('ticket-card-header', className)}>{children}</div>;
}

TicketCardHeader.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node
};

export function TicketCardContent({ children = null, className = '', ticket = false }) {
    return <div className={classnames('ticket-card-content', ticket && 'ticket-card-content-ticket')}>{children}</div>;
}

TicketCardContent.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    ticket: PropTypes.bool
};

export function TicketCardFooter({ children = null, className = '' }) {
    return <div className={classnames('ticket-card-footer', className)}>{children}</div>;
}

TicketCardFooter.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node
};

export default function TicketCard({ children = null, className = '', ...rest }) {
    return (
        <div className={classnames('ticket-card', className)} {...rest}>
            {children}
        </div>
    );
}

TicketCard.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node
};

TicketCard.Header = TicketCardHeader;
TicketCard.Content = TicketCardContent;
TicketCard.Footer = TicketCardFooter;
